module.exports = __webpack_public_path__ + "img/deb4c6c47985187ff65137c2224c1f87.393f3068.png";